import { Form } from '@anytag/shared-atoms';
import { namedOperations } from '@anytag/graphql';
import { formatPercent } from '@anytag/shared-utils';
import { getRevenueItems } from '../utils';
import { UpdateCostsFormValues, useUpdatePostPrices } from '../../hooks';
import { Template, TemplateProps } from './template';

export type MarketplaceJoinedInfluencersListProps = TemplateProps;
export const MarketplaceJoinedInfluencersList = (props: MarketplaceJoinedInfluencersListProps) => {
  const { data, marketplace } = props;

  const { handleUpdatePostPrices } = useUpdatePostPrices({
    marketplaceId: marketplace.id,
    refetchQueries: [namedOperations.Query.MarketplaceAffiliateJoinedInfluencers]
  });

  return (
    <Form.Provider<UpdateCostsFormValues>
      onSubmit={handleUpdatePostPrices}
      values={data?.reduce<UpdateCostsFormValues>((acc, curr) => {
        const { influencerCommissionRate, revenuePerAction, revenuePerClick } = getRevenueItems(curr.revenueItems);

        acc[`${curr.influencer.id}_influencerCommissionRate`] =
          formatPercent(influencerCommissionRate?.value, false) || '';
        acc[`${curr.influencer.id}_revenuePerClick`] = revenuePerClick?.value?.toString() || '';
        acc[`${curr.influencer.id}_revenuePerAction`] = revenuePerAction?.value?.toString() || '';

        return acc;
      }, {})}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} />
    </Form.Provider>
  );
};
